import store from '@/store';

export default class Permissions {
    constructor(dto, objectLock) {
        this.documentRead = false;
        this.documentEdit = false;
        this.documentDelete = false;
        this.documentDownload = false;
        this.documentPrint = false;
        this.documentSign = false;
        this.documentExternalDistribution = false;
        this.documentAttachmentCreate = false;
        this.documentAttachmentDelete = false;
        this.documentAttachmentRead = false;
        this.documentAttachmentUpdate = false;
        this.documentAttachmentDownload = false;
        this.commentCreate = false;
        this.commentRead = false;
        this.commentUpdate = false;
        this.commentDelete = false;
        this.auditRead = false;

        if (dto) {
            this.documentRead = dto.DocumentRead;
            this.documentEdit = dto.DocumentEdit;
            this.documentDelete = dto.DocumentDelete;
            this.documentDownload = dto.DocumentDownload;
            this.documentPrint = dto.DocumentPrint;
            this.documentSign = dto.DocumentSign;
            this.documentExternalDistribution = dto.DocumentExternalDistribution;
            this.documentAttachmentCreate = dto.DocumentAttachmentCreate;
            this.documentAttachmentDelete = dto.DocumentAttachmentDelete;
            this.documentAttachmentRead = dto.DocumentAttachmentRead;
            this.documentAttachmentUpdate = dto.DocumentAttachmentUpdate;
            this.documentAttachmentDownload = dto.DocumentAttachmentDownload;
            this.commentCreate = dto.CommentCreate;
            this.commentRead = dto.CommentRead;
            this.commentUpdate = dto.CommentUpdate;
            this.commentDelete = dto.CommentDelete;
            this.auditRead = dto.AuditRead;
        }

        if (objectLock) {
            if (objectLock.UserID != store.getters['account/user'].Id) {
                this.documentEdit = false;
                this.documentDelete = false;
                this.documentSign = false;
            }
        }
    }
}
